import React from "react";
import { DashboardTabs } from "./dashboardTabs";

export const DashboardPage: React.FC = () => {
  return <DashboardTabs />;
};
